import Repository from "./Repository";

const resource = "/test";

export default {
    // get(){
    //     return Repository.get(`${resource}`);
    // },
    post(payload) {
        return Repository.post(`${resource}/${payload.testId}/attemp`, payload.attemp);
    },
    get(payload) {
        return Repository.get(`${resource}/${payload.test.id}/attemp/${payload.attemp.id}`);
    },
    getAttemps(payload) {
        return Repository.get(`${resource}/${payload.test.id}/attemp?user=${payload.user.id}&status=${payload.status}`);
    },
    getCertificate(payload) {
        return Repository.get(`${resource}/${payload.idTest}/attemp/${payload.idAttemp}`);
    },
    put(payload) {
        // console.log(payload)
        return Repository.post(`${resource}/${payload.id}`, payload);

    },
    patch(payload) {
        // console.log(payload)
        let body = payload.attemp.questions.map((q)=>{return {"question":q.id,"option":q.response}});
        return Repository.patch(`${resource}/${payload.test.id}/attemp/${payload.attemp.id}`, body);

    }
}